import { render, staticRenderFns } from "./ResultsSurveysList.vue?vue&type=template&id=810e1204&scoped=true"
import script from "./ResultsSurveysList.vue?vue&type=script&lang=js"
export * from "./ResultsSurveysList.vue?vue&type=script&lang=js"
import style0 from "./ResultsSurveysList.vue?vue&type=style&index=0&id=810e1204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e1204",
  null
  
)

export default component.exports